// One setting inside a settings section, the same on a project's Settings tab and the
// team settings page: its name, what it is, what switching it on costs, then its controls.
import type { ReactNode } from "react";

import styles from "./SettingSubcard.module.css";

export const SettingSubcard = ({
  title,
  describe,
  notes = [],
  warning = null,
  children,
}: {
  title: ReactNode;
  describe: string;
  notes?: string[];
  warning?: string | null;
  children: ReactNode;
}) => (
  <section className={styles.subcard}>
    <h3 className={styles.title}>{title}</h3>
    <p className={styles.muted}>{describe}</p>
    {notes.map((note) => (
      <p key={note} className={styles.muted}>
        {note}
      </p>
    ))}
    {warning && (
      <p className={styles.warning} role="note">
        {warning}
      </p>
    )}
    {children}
  </section>
);
